module.exports = __webpack_public_path__ + "img/figuur1.3afc068d.svg";